import React from "react";
import { Route } from "react-router-dom";
import { TopUpCard } from "./TopUpCard";
import { TopUpUIProvider } from "./TopUpUIContext";
import { PrivateRoute } from "../../../PrivateRoute";
import { RoleChecker } from "../../../RoleChecker";

export function TopUpPage({ history }) {
  const topUpUIEvents = {
    newTopUpIndividuButtonClick: () => {
      history.push("/topUp/individual/new");
    },
    newTopUpOrganizationButtonClick: () => {
      history.push("/topUp/organization/new");
    },
    openEditTopUpIndividualPage: (id) => {
      history.push(`/topUp/individual/${id}/edit`);
    },
    openEditTopUpOrganizationPage: (id) => {
      history.push(`/topUp/organization/${id}/edit`);
    },
    openDeleteTopUpPage: (id) => {
      history.push(`/topUp/${id}/delete`);
    },
  };

  return (
    <TopUpUIProvider topUpUIEvents={topUpUIEvents}>
      <TopUpCard history={history} />
    </TopUpUIProvider>
  );
}
